var _path, _rect, _rect2, _g, _path2, _path3, _rect3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopBottomStrikeZoneImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 608,
    height: 196,
    viewBox: "0 0 608 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M342.661 11.3671C342.934 11.0945 342.934 10.6526 342.661 10.38L338.22 5.93839C337.947 5.66583 337.505 5.66583 337.233 5.93839C336.96 6.21095 336.96 6.65286 337.233 6.92542L341.181 10.8735L337.233 14.8217C336.96 15.0942 336.96 15.5361 337.233 15.8087C337.505 16.0812 337.947 16.0812 338.22 15.8087L342.661 11.3671ZM266.065 10.38C265.792 10.6526 265.792 11.0945 266.065 11.367L270.506 15.8087C270.779 16.0812 271.221 16.0812 271.493 15.8087C271.766 15.5361 271.766 15.0942 271.493 14.8217L267.545 10.8735L271.493 6.92541C271.766 6.65285 271.766 6.21095 271.493 5.93838C271.221 5.66582 270.779 5.66582 270.506 5.93838L266.065 10.38ZM342.168 10.1756L266.558 10.1756L266.558 11.5715L342.168 11.5715L342.168 10.1756Z",
    fill: "#EC691A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "strikezone-width",
    x: 289.597,
    y: 0.547119,
    width: 30.3058,
    height: 20.3265,
    rx: 2.5503,
    fill: "#EC691A"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.393903
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1416_14445",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 152,
    width: 607,
    height: 73
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.850586,
    y: 152.98,
    width: 606.041,
    height: 71.8794,
    fill: "url(#paint0_linear_1416_14445)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1416_14445)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M350.234 168.299L372.523 212.96H391.409L367.636 168.299H350.234Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M582.482 212.96L498.464 168.299H515.45L604.322 212.96H582.482Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M582.482 212.96H388.471L386.166 209.85H576.566L582.482 212.96Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M505.885 170.656H364.717L362.971 168.299H501.405L505.885 170.656Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.582 168.299L236.293 212.96H217.407L241.18 168.299H258.582Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3348 212.96L110.353 168.299H93.3672L4.49539 212.96H26.3348Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3342 212.96H220.345L222.65 209.85H32.2502L26.3342 212.96Z",
    fill: "#414141"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.932 170.656H244.101L245.846 168.299H107.412L102.932 170.656Z",
    fill: "#414141"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.414 179.307L274.389 178.827H334.956L336.764 179.307L338.398 183.555L304.402 187.443L270.406 183.555L272.414 179.307Z",
    fill: "#F5F5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.229 178.827H334.928L336.469 182.826L304.402 186.486L272.335 182.826L274.229 178.827Z",
    fill: "#E0E0E0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "strikezone-middle",
    x: 267.338,
    y: 28.5145,
    width: 74.7452,
    height: 97.1643,
    rx: 0.719378,
    stroke: "#222222",
    strokeWidth: 0.479586
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57294,
    d: "M293.768 29.2063V125.531",
    stroke: "#222222",
    strokeWidth: 0.479586,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57294,
    d: "M317.021 29.2063V125.531",
    stroke: "#222222",
    strokeWidth: 0.479586,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57294,
    d: "M267.607 62.2679H341.812",
    stroke: "#222222",
    strokeWidth: 0.479586,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57294,
    d: "M267.607 91.9258H341.812",
    stroke: "#222222",
    strokeWidth: 0.479586,
    strokeLinecap: "square"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M184.382 180.918H305.874",
    stroke: "#E0E0E0",
    strokeWidth: 1.29247,
    strokeDasharray: "2.58 5.82"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M228.326 125.342L267.1 125.342",
    stroke: "#E0E0E0",
    strokeWidth: 1.29247,
    strokeDasharray: "2.58 5.82"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M184.382 28.406L267.1 28.406",
    stroke: "#E0E0E0",
    strokeWidth: 1.29247,
    strokeDasharray: "2.58 5.82"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1416_14445",
    x1: 4.15587,
    y1: 223.579,
    x2: 588.598,
    y2: 223.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514444,
    stopColor: "#E3E3E3",
    stopOpacity: 0.0791357
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8",
    stopOpacity: 0.05
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopBottomStrikeZoneImage);
export default __webpack_public_path__ + "static/media/topBottomStrikeZoneImage.f0f19f00130d3240512eea7b17296c24.svg";
export { ForwardRef as ReactComponent };